import { LeadSourcesTable } from "./LeadSourcesTable";
import { Button } from "@/components/ui/button";
import { Users } from "lucide-react";
import { useState } from "react";
import { LeadSourceDialog } from "./LeadSourceDialog";
import { useLeadSourceOperations } from "./useLeadSourceOperations";

export const LeadSourcesContainer = () => {
  const [showDialog, setShowDialog] = useState(false);
  const { createLeadSource } = useLeadSourceOperations();

  const handleCreate = async (name: string, description: string) => {
    await createLeadSource(name, description);
    setShowDialog(false);
  };

  return (
    <div>
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-2xl font-semibold">Manage Lead Sources</h2>
        <Button onClick={() => setShowDialog(true)} className="bg-primary hover:bg-primary/90 text-white">
          <Users className="h-4 w-4 mr-2" />
          Add Lead Source
        </Button>
      </div>
      <LeadSourcesTable />

      <LeadSourceDialog
        isOpen={showDialog}
        onClose={() => setShowDialog(false)}
        onSubmit={handleCreate}
        mode="create"
      />
    </div>
  );
};